var _path, _path2, _path3, _path4, _g, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTerraLogoIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 26C20.1797 26 26 20.1797 26 13C26 5.8203 20.1797 0 13 0C5.8203 0 0 5.8203 0 13C0 20.1797 5.8203 26 13 26Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9388 17.8573C12.4225 19.7045 14.1605 21.1137 15.0377 21.0553C15.0682 21.0528 18.3664 20.4193 20.1717 17.3102C21.5771 14.8904 21.0984 12.5545 19.1878 12.5037C18.4997 12.5558 11.0158 14.3395 11.9388 17.8573ZM13.598 3.95216C12.3539 3.95216 11.172 4.21876 10.1043 4.69611C9.91768 4.77482 9.73487 4.86369 9.5584 4.96398C9.4378 5.02873 9.31592 5.0922 9.19912 5.16203L9.22705 5.17091C8.87285 5.41593 8.56817 5.70285 8.31807 6.03293C5.84756 9.30578 14.1313 11.6836 18.5594 11.6925C20.597 13.1575 21.1695 7.56525 19.1789 6.01261C17.625 4.67834 15.6445 3.94835 13.598 3.95216Z",
    fill: "#0E3CA5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4852 5.87022C9.36543 7.51553 5.63428 8.67461 5.02109 8.49434L5.01855 8.48799L5.09473 8.33946C5.73584 7.13721 6.64609 6.09873 7.75439 5.30527C7.98418 5.14023 8.22158 4.98662 8.46787 4.84316C8.98838 4.54736 9.52412 4.52959 9.70058 4.52197C11.3611 4.55244 10.494 5.85752 10.4852 5.87022Z",
    fill: "#5493F7"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_17368_50589",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 9,
    width: 7,
    height: 13
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.87695 9.65381H9.57841V21.0567H3.87695V9.65381Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_17368_50589)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.54515 18.199C9.62894 18.7398 9.54261 20.8752 9.43089 21.0555C9.33441 21.0605 9.13255 21.0732 8.55111 20.7508C7.42122 20.1147 6.43734 19.2477 5.66419 18.2079C5.09798 17.4462 4.65491 16.5994 4.34896 15.7006C4.03538 14.77 3.87542 13.795 3.87796 12.8137C3.87669 11.7346 4.06839 10.6644 4.44671 9.65381H4.44798C5.11575 10.5298 5.88763 11.322 6.54398 12.2068C7.16986 13.0485 8.02933 14.4209 8.20326 14.7142C9.2887 16.5359 9.46263 17.6595 9.54515 18.199Z",
    fill: "#5493F7"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.1222 12.9149C22.1222 14.0829 21.9001 15.1988 21.4964 16.2233C20.4388 17.3646 13.3079 14.5564 13.2368 14.526C12.2618 14.0969 9.29236 12.7931 9.02448 10.7428C8.64109 7.79492 14.6041 5.74082 17.2244 5.66211C17.538 5.66592 18.4952 5.67734 19.0512 6.13184C21.0063 7.84316 22.1261 10.3162 22.1222 12.9149ZM15.8863 20.2071C16.3129 18.6977 20.0415 17.1501 20.8641 17.0676C20.9657 17.0574 21.0089 17.1285 20.9644 17.211C20.1062 18.7726 18.8354 20.0573 17.2968 20.8914C16.5198 21.2672 15.6641 20.993 15.8863 20.2071Z",
    fill: "#5493F7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerraLogoIcon);
export default __webpack_public_path__ + "static/media/TerraLogoIcon.36d890b3.svg";
export { ForwardRef as ReactComponent };